import React from 'react'

import {
  ProspectNameAndDobCollectionFormUI,
  ProspectNameAndDobCollectionFormValues,
} from '~/components/screens/ProspectNameAndDobCollectionFormUI'
import { useBffWebOnboardingCreateNewAccount } from '../utils'
import { useTenantConfigQuery } from '~/utils/useTenantConfigQuery'

/**
 * The authenticated `prospect_name_and_dob_collection` step. Prospects on the current flow satisfy
 * it before the account exists, on the unauthenticated `ProspectNameDobCollection`, so the engine normally
 * evaluates it as already complete; it exists to serve a prospect who reaches an authenticated
 * session without a name — a dropped-off or partially created signup — rather than letting the flow
 * carry them on nameless.
 */
const AuthenticatedProspectNameDobCollection: React.FC = () => {
  const { data: tenantData, isLoading: tenantConfigLoading } = useTenantConfigQuery()
  const { handler: createAccount, loading: createAccountLoading } =
    useBffWebOnboardingCreateNewAccount()

  const tenantConsentForms = tenantData?.consentForms?.filter(
    consentForm => consentForm.needsSignature,
  )

  const initialValues: ProspectNameAndDobCollectionFormValues = {
    preferredName: '',
    dob: '',
    termsAndConditions: false,
    consentForms: [],
  }

  const handleSubmit = async (values: ProspectNameAndDobCollectionFormValues) => {
    const consentForms = values.termsAndConditions ? tenantConsentForms?.map(f => f.id) || [] : []

    // No `firstName` / `lastName`: a prospect's legal name is collected at member conversion, and
    // the hook omits the pair from the payload rather than sending it blank.
    await createAccount({
      preferredName: values.preferredName,
      dob: values.dob,
      consentForms: consentForms,
    })
  }

  return (
    <ProspectNameAndDobCollectionFormUI
      initialValues={initialValues}
      onSubmit={handleSubmit}
      isLoading={tenantConfigLoading || createAccountLoading}
    />
  )
}

export default AuthenticatedProspectNameDobCollection
